<template>
    <div class="mt-6">
        <h3 class="mb-4">
            Executar o processo manual
        </h3>
        <v-btn color="primary" rounded @click="executarInformacoesPropostaManualmente">
            INFORMACOESPROPOSTASYNC
        </v-btn>
    </div>
</template>

<script>

  import { ComandosDoSchedule } from '../../../enums/agendamentos_schedule/commands'
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '@/plugins/alerts_types'

  export default {
    name: 'ExecucaoManualSyncPropostas',
    methods: {
      executarInformacoesPropostaManualmente () {
        this.$http.post('/painel/agendamentos/agendar_comando', { comando: ComandosDoSchedule.propostasResumida }).then(({ data }) => {
          notification(AlertTypes.INFO, data.message)
        }).catch((err) => {
          notification(AlertTypes.ERROR, err)
        })
      }
    }
  }
</script>
